import { type ReactNode } from "react";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
import {
  panelAccentDot,
  panelFieldLabel,
  panelSectionHeader,
  panelSectionTitle,
} from "@/lib/panel-ui";

export {
  panelAccentDot,
  panelAlert,
  panelBody,
  panelChoice,
  panelChoiceOn,
  panelControl,
  panelDialog,
  panelEmpty,
  panelFieldLabel,
  panelHint,
  panelPage,
  panelPill,
  panelRow,
  panelSectionHeader,
  panelSectionTitle,
  panelSurface,
  panelTitle,
} from "@/lib/panel-ui";

export function PanelSectionHeading({ children }: { children: ReactNode }) {
  return (
    <div className={panelSectionHeader}>
      <h2 className="flex items-center gap-2.5">
        <span className={panelAccentDot} aria-hidden />
        <span className={panelSectionTitle}>{children}</span>
      </h2>
    </div>
  );
}

export function PanelFieldLabel({
  children,
  className,
  htmlFor,
}: {
  children: string;
  className?: string;
  htmlFor?: string;
}) {
  const required = /\s*\*$/.test(children);
  const text = children.replace(/\s*\*$/, "");
  return (
    <Label htmlFor={htmlFor} className={cn(panelFieldLabel, className)}>
      {text}
      {required && <span className="ml-0.5 text-primary">*</span>}
    </Label>
  );
}
